import { Module } from "vuex";
import { State } from "@/store/modules/wine_type/state";
import Mutations from "@/store/modules/wine_type/mutations";
import Getters from "@/store/modules/wine_type/getters";
import Actions from "@/store/modules/wine_type/actions";

export class WineType implements Module<State, any> {
  namespaced: boolean = true;
  state: State;
  mutations = Mutations;
  getters = Getters;
  actions = Actions;

  // Setup CRUD operations
  constructor() {
    this.state = new State();
  }
}
